import { NavigationExtras, Router } from '@angular/router';

export const PARAM_TOKEN = null;

export abstract class NavigatorBase {
  fixPath(path: any[]): any[] {
    if (path.length > 0 && typeof path[0] == 'string') {
      const s: string = path[0];
      if (!s.startsWith('/')) {
        path[0] = `/${s}`;
      }
    }
    return path;
  }
}

export class Navigator extends NavigatorBase {
  private path: any[];

  constructor(private router: Router, ...path: any[]) {
    super();
    this.path = this.fixPath(path);
  }

  navigate(extras?: NavigationExtras) {
    return this.router.navigate(this.path, extras);
  }
}

export class NavigatorWithParam<T> extends NavigatorBase {
  private path: any[];

  constructor(private router: Router, ...path: any[]) {
    super();
    this.path = this.fixPath(path);
  }

  navigate(value: T, extras?: NavigationExtras) {
    const fullpath = [...this.path];
    if (fullpath.some(part => part === PARAM_TOKEN)) {
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value);
    } else {
      fullpath.push(value);
    }
    return this.router.navigate(fullpath, extras);
  }


  navigate2(value: T, outlets) {
    const fullpath = [...this.path];
    if (fullpath.some(part => part === PARAM_TOKEN)) {
      fullpath.splice(fullpath.indexOf(PARAM_TOKEN), 1, value);
      return this.router.navigate([...fullpath], outlets);
    } else {
      return this.router.navigate([...fullpath, value], outlets);
    }
  }
}

export class NavigatorWith2Params<T, U> extends NavigatorBase {
  private path: any[];

  constructor(private router: Router, ...path: any[]) {
    super();
    this.path = this.fixPath(path);
  }

  /**
   * Remplace les 2 occurrences de PARAM_TOKEN par leurs positions (pas en recherchant
   * `indexOf(PARAM_TOKEN)` une 2e fois après la 1re substitution) : PARAM_TOKEN vaut `null`, donc
   * si value1 est lui-même `null` (ex. un id pas encore renseigné côté back), la 1re substitution
   * ne change rien à la valeur de la case — un `indexOf` suivant retomberait sur cette même case
   * au lieu de la 2e occurrence réelle, et décalerait silencieusement value2 à la mauvaise place.
   */
  private remplacerParametres(value1: T, value2: U): any[] {
    const fullpath = [...this.path];
    const indices = fullpath.reduce<number[]>((acc, part, i) => (part === PARAM_TOKEN ? [...acc, i] : acc), []);
    if (indices.length >= 2) {
      fullpath[indices[0]] = value1;
      fullpath[indices[1]] = value2;
      return fullpath;
    }
    return [...fullpath, value1, value2];
  }

  navigate(value1: T, value2: U) {
    return this.router.navigate(this.remplacerParametres(value1, value2));
  }

  navigate2(value1: T, value2: U, outlets) {
    return this.router.navigate(this.remplacerParametres(value1, value2), outlets);
  }
}
